import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LocationSEO } from '../data/seoTemplates';

interface SEOContextType {
  seoData: LocationSEO | null;
  setSeoData: (data: LocationSEO | null) => void;
}

const SEOContext = createContext<SEOContextType | undefined>(undefined);

export const useSEOContext = () => {
  const context = useContext(SEOContext);
  if (context === undefined) {
    throw new Error('useSEOContext must be used within a SEOProvider');
  }
  return context;
};

interface SEOProviderProps {
  children: ReactNode;
}

export const SEOProvider: React.FC<SEOProviderProps> = ({ children }) => {
  const [seoData, setSeoData] = useState<LocationSEO | null>(null);

  return (
    <SEOContext.Provider value={{ seoData, setSeoData }}>
      {children}
    </SEOContext.Provider>
  );
};
